import { Component, OnInit } from "@angular/core";
import { FormBuilder, Validators } from "@angular/forms";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-insert-user-dialog",
  templateUrl: "./insert-user-dialog.component.html",
  styleUrls: ["./insert-user-dialog.component.scss"],
})
export class InsertUserDialogComponent implements OnInit {
  insertUserForm = this.fb.group({
    username: [null, Validators.required],
    email: [
      null,
      Validators.compose([
        Validators.required,
        Validators.email,
        Validators.pattern("^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$"),
      ]),
    ],
    password: [null, Validators.required],
    senders: [[]],
  });

  constructor(
    public dialogRef: MatDialogRef<InsertUserDialogComponent>,
    private fb: FormBuilder
  ) {}

  ngOnInit(): void {}

  onSubmit() {
    const formValue = this.insertUserForm.value;
    this.dialogRef.close(formValue);
  }

  closeCancelling() {
    this.dialogRef.close();
  }
}
